import { useMutation, useQueryClient } from "react-query";

import { PLAY_TO_3D_DATA_PRIVATE_SOURCES_QUERY_KEYS } from "hooks/usePlayTo3DDataPrivateSources";
import { PLAY_TO_3D_DATA_SOURCES_QUERY_KEYS } from "hooks/usePlayTo3DDataSources";

import { updateSourceAccessUsers } from "api/ipdp";
import type { IpdbSourcePlay } from "api/ipdp";

import { GEO_MODEL_ACCESS_QUERY_KEYS } from "./useGeoModelAccessQuery";

export const useUpdateSourceAccess = () => {
  const queryClient = useQueryClient();

  return useMutation<
    () => void,
    Error,
    { source: string; userList: string[] },
    { previousData?: IpdbSourcePlay[] }
  >({
    mutationFn: ({ source, userList }) => updateSourceAccessUsers(source, userList),
    onMutate: async ({ source, userList }) => {
      await queryClient.cancelQueries([GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess]);
      const previousData = queryClient.getQueryData<IpdbSourcePlay[]>([
        GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess
      ]);
      if (previousData) {
        queryClient.setQueryData(
          [GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess],
          previousData.map((item) =>
            item.source === source ? { ...item, userList } : item
          )
        );
      }
      return { previousData };
    },
    onError: (err, variables, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(
          [GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess],
          context.previousData
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries([GEO_MODEL_ACCESS_QUERY_KEYS.geoModelAccess]);
      queryClient.invalidateQueries([
        PLAY_TO_3D_DATA_PRIVATE_SOURCES_QUERY_KEYS.playTo3DDataPrivateSources
      ]);
      queryClient.invalidateQueries([
        PLAY_TO_3D_DATA_SOURCES_QUERY_KEYS.playTo3DDataSources
      ]);
    }
  });
};
